import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { MatrixService } from 'src/Services/matrix.service';
import { ActionCompanySpecificCategoryModel, ActionGetByIdModel, AddNewActionModel, userModel } from 'src/Models/TracItModel';
import { ActionItemService } from 'src/Services/tracit.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-edit-action-popup',
  templateUrl: './edit-action-popup.component.html',
  styleUrls: ['./edit-action-popup.component.css']
})
export class TracItEditActionPopupComponent implements OnInit {
  @Input() IsActionFlag: any;
  @Input() title: string;
  addNewActionModel = new AddNewActionModel();
  userModel: userModel[];

  loginUser: number = 0;
  message: string;
  isCheckVisibleToAllCompanyUsers: boolean;
  tokenKey: string = '';
  companyId: number = 0;

  dropdownUserSettings = {};
  selectedItemsUser = [];
  dropdownListUser = [];

  dropdownCarrierCategoriesSettings = {};
  selectedItemsCarrierCategories = [];
  dropdownListCarrierCategories = [];
  listofcarriercategories: number[] = [];

  dropdownStateSettings = {};
  selectedItemsState = [];
  dropdownListState = [];
  listofState: number[] = [];
  productId: number;

  listOfAssignToUser = [];
  dropdownCountrySettings = {};
  selectedItemsCountry = [];
  dropdownListCountry = [];
  dropdownSingleSettings = {};
  selectedItemsVisible = [];
  dropdownListVisible = [];
  dropdownUsersSettings = {};
  selectedItemsReminderUsers = [];
  selectedItemsVisibleUsers = [];
  selectedItemsRecurrance = [];
  dropdownListRecurrance = [];
  selectedItemsReminder = [];
  dropdownListReminder = [];
  selectedItemsCompanySpecificCategory = [];
  dropdownListCompanySpecificCategory = [];
  isCountryUserSelected = false;
  isSpecificUserVisible = false;
  isAddNewCategory = false;
  isReminderUser = false;
  addNewCategoryText = '';
  dropdownRecurranceSettings = {}
  isRecurrenceRecord = false;

  addUpdateActionItem = new FormGroup({
    assignToUser: new FormControl(''),
    actionItemId: new FormControl(''),
    recurranceId: new FormControl(''),
    deadLineDate: new FormControl(''),
    subject: new FormControl(''),
    description: new FormControl(''),
    visibleTrackIt: new FormControl(0),
    state: new FormControl(''),
    carrierCategories: new FormControl(''),
    visibleUserIds: new FormControl(''),
    category: new FormControl(''),
    categoryText: new FormControl(''),
    country: new FormControl(''),
    recurrance: new FormControl(''),
    reminder: new FormControl(''),
    reminderUsers: new FormControl(''),
    alertText: new FormControl(''),
  });

  EditActionId: number = 0;
  editModel = new ActionGetByIdModel();
  isOneClickOnButton: boolean = false;
  selectedItems: any;
  bsConfig = {
  showWeekNumbers: false,
  dateInputFormat: 'MM/DD/YYYY',
  minDate: new Date()   // disables past dates
};

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  constructor(private readonly matrix: MatrixService,
    private readonly toastr: ToastrService,
    private readonly actionItemServices: ActionItemService,
    private readonly activeModal: NgbActiveModal,
    private readonly checkAuth: CheckAuth,
    private sessionStorageService: SessionStorageService) {
    this.title = 'Edit Trac-It';
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.selectedItems = '1';
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.companyId = +sessionStorage.getItem("CompanyId");
    this.loginUser = +sessionStorage.getItem('UserId');
    this.productId = 4;
    this.EditActionId = +sessionStorage.getItem('EditActionId');
    this.ActionGetById();
    this.selectedItems = '1';
    this.dropdownSingleSettings = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false,
    };
    this.dropdownRecurranceSettings = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false,
      disabled: true
    };
  }

  viewAllCompanyUser($event) {
    this.isCheckVisibleToAllCompanyUsers = $event.target.checked;
    this.selectedItemsUser = [];
    this.UserDropDownSettings();
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  ActionGetById() {
    this.actionItemServices.ActionGetById(this.tokenKey, this.EditActionId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.editModel = data['model'];
          if (this.editModel != null) {
            const dd = new Date(this.editModel.deadlineDate);
            var dDate = [this.pad(dd.getMonth() + 1), this.pad(dd.getDate()), dd.getFullYear()].join('/');

            this.addUpdateActionItem.setValue({
              assignToUser: [],
              actionItemId: this.editModel.actionId,
              recurranceId: this.editModel.recurranceId,
              deadLineDate: dDate,
              subject: this.editModel.subject,
              description: this.editModel.description,
              visibleTrackIt: [],
              state: [],
              carrierCategories: [],
              visibleUserIds: [],
              category: [],
              categoryText: [],
              country: [],
              recurrance: [],
              reminder: [],
              reminderUsers: [],
              alertText: this.editModel.alertText,
            });
            if (this.editModel.recurranceId == 0)
              this.isRecurrenceRecord = false
            else
              this.isRecurrenceRecord = true
            this.addNewActionModel.actionItemId = this.editModel.actionId;
            this.addNewActionModel.recurranceId = this.editModel.recurranceId;
            this.isCheckVisibleToAllCompanyUsers = this.editModel.visibleTrackIt > 0;
            this.addNewActionModel.assignToUser = this.editModel.assignToId.toString();

            this.GetUsersFindByCompanyId(this.companyId);
            this.GetCarrierCategories();
            this.GetStates(this.loginUser, this.productId);
            this.GetAllCountry();
            this.GetAllVisible();
            this.GetAllRecurrance();
            this.GetAllReminders();
            this.GetAllCompanyServiceCategory();
            this.AssignUserDropDownSettings();
          }
        }
        else {
          this.showMessage(data['status'], 'Error', 'error');
        }
      }
    );
  }

  saveAddUpdateActionItem(addUpdateActionItem: any, isButtonDisable: boolean, isclickfrompopup: boolean) {

    if (isclickfrompopup && this.isRecurrenceRecord) {
      document.getElementById("btnopenEditpopup").click();
      return;
    }

    event.preventDefault();

    if (!this.selectedItemsVisible || this.selectedItemsVisible.length == 0) {
      this.showMessage('Please select visible type', 'Error', 'error');
      return;
    }
    this.addNewActionModel.visibleTrackIt = this.selectedItemsVisible[0].id;
    if (this.addNewActionModel.visibleTrackIt == 2 && this.selectedItemsVisibleUsers.length == 0) {
      this.showMessage('Please select visible users', 'Error', 'error');
      return;
    }

    if (addUpdateActionItem.value['deadLineDate'] == undefined || addUpdateActionItem.value['deadLineDate'] == '') {
      this.showMessage('Please select deadline date', 'Error', 'error');
      return;
    }
    let currentDate = new Date();
    if (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) > addUpdateActionItem.value["deadLineDate"]) {
      this.showMessage('Previous deadline date not allow', 'Error', 'error');
      return;
    }
    if (addUpdateActionItem.value['subject'] == undefined || addUpdateActionItem.value['subject'] == '') {
      this.showMessage('Please enter subject', 'Error', 'error');
      return;
    }
    if (addUpdateActionItem.value['description'] == undefined || addUpdateActionItem.value['description'] == '') {
      this.showMessage('Please enter description', 'Error', 'error');
      return;
    }

    if (this.selectedItemsVisible[0].id == 0 && this.selectedItemsReminderUsers.length > 1) {
      this.showMessage('You can not select more then one user because trac-it visibility is “Visible to me only”.', 'Error', 'error');
      return;
    }

    if (this.selectedItemsCountry.length > 0)
      this.addNewActionModel.country = this.selectedItemsCountry[0].id;
    if (this.selectedItemsRecurrance.length > 0)
      this.addNewActionModel.recurrance = this.selectedItemsRecurrance[0].id;
    if (this.selectedItemsReminder.length > 0)
      this.addNewActionModel.reminder = this.selectedItemsReminder[0].id;
    if (this.selectedItemsCompanySpecificCategory.length > 0)
      this.addNewActionModel.category = this.selectedItemsCompanySpecificCategory[0].id;
    if (this.addNewActionModel.reminder != 'None' && this.selectedItemsReminderUsers.length == 0) {
      this.showMessage('Please select reminder users', 'Error', 'error');
      return;
    }
    if (this.addNewActionModel.reminder != 'None' && this.selectedItemsReminderUsers.length > 0 && !this.selectedItemsReminderUsers.find(x => x.id == this.loginUser)) {
      this.showMessage('You can not remove current user from reminder user', 'Error', 'error');
      return;
    }
    this.addNewActionModel.reminderUsers = this.selectedItemsReminderUsers;
    this.addNewActionModel.visibleUserIds = this.selectedItemsVisibleUsers;
    this.addNewActionModel.state = this.selectedItemsState.map(x => x.id).join(',');
    this.addNewActionModel.carrierCategories = this.listofcarriercategories.join(',');

    if (addUpdateActionItem.value['actionItemId'] != 'undefined' && addUpdateActionItem.value['actionItemId'] != undefined)
      this.addNewActionModel.actionItemId = addUpdateActionItem.value['actionItemId'];
    else
      this.addNewActionModel.actionItemId = 0;

    if (this.addNewActionModel.assignToUser == null)
      this.addNewActionModel.assignToUser = '0';

    if (addUpdateActionItem.value['visibleToAllCompanyUsers'] != 'undefined' && addUpdateActionItem.value['visibleToAllCompanyUsers'] != undefined)
      this.addNewActionModel.visibleToAllCompanyUsers = addUpdateActionItem.value['visibleToAllCompanyUsers'];
    else
      this.addNewActionModel.visibleToAllCompanyUsers = false;

    if (addUpdateActionItem.value['description'] != undefined)
      this.addNewActionModel.description = addUpdateActionItem.value['description'];
    else
      this.addNewActionModel.description = null;

    if (addUpdateActionItem.value['alertText'] != undefined)
      this.addNewActionModel.alertText = addUpdateActionItem.value['alertText'];
    else
      this.addNewActionModel.alertText = null;

    this.addNewActionModel.subject = addUpdateActionItem.value['subject'];
    this.addNewActionModel.createdBy = +sessionStorage.getItem('UserId');
    this.addNewActionModel.companyId = this.companyId;
    this.addNewActionModel.actionItemId = this.EditActionId;
    this.addNewActionModel.productId = this.productId.toString();

    if (isButtonDisable) {
      return;
    }

    this.isOneClickOnButton = true;

    this.addNewActionModel.selectedItems = this.selectedItems;

    this.actionItemServices.EditActionItem(this.tokenKey, this.addNewActionModel).subscribe(
      data => {
        this.isOneClickOnButton = false;
        if (data['status'] == 'Success') {
          this.showMessage('Entry updates successfully', 'Success', 'success');
          this.activeModal.close('Yes');
        }
        else {
          this.showMessage(data['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
        this.isOneClickOnButton = false;
      }
    );
  }

  GetUsersFindByCompanyId(companyId: any) {
    this.actionItemServices.GetUsersFindByCompanyIdRemoveLoginUser(this.tokenKey, companyId, this.productId, this.loginUser).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.userModel = data['companyUsers'];
          if (this.userModel != null) {
            if (this.userModel.length > 0) {
              for (let iCounter = 0; iCounter < this.userModel.length; iCounter++) {
                this.dropdownListUser.push({ "id": parseInt(this.userModel[iCounter].userId), "itemName": this.userModel[iCounter].userName });
              }

              if (this.editModel != null) {
                if (this.editModel.assignToId > 0) {
                  let model = this.userModel.filter(m => +m.userId == this.editModel.assignToId);
                  this.selectedItemsUser.push({ "id": parseInt(model[0].userId), "itemName": model[0].userName });
                  this.addNewActionModel.previousAssingId = model[0].userId;
                }
              }
            }
          }
        }
        this.UserDropDownSettings();

      });
  }

  UserDropDownSettings() {
    this.dropdownUserSettings = {
      singleSelection: true,
      text: "Select User",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No user available',
      showCheckbox: false,
      disabled: !this.isCheckVisibleToAllCompanyUsers
    };
  }
  onSelectedUser($event) {
    this.addNewActionModel.assignToUser = $event['id'];
  }

  onDeSelectedUser($event) {
    this.addNewActionModel.assignToUser = null;
  }

  onDeSelectAllUser($event) {
    this.addNewActionModel.assignToUser = null;
  }

  GetCarrierCategories() {
    this.actionItemServices.GetCarrierCategories(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.listofcarriercategories = [];
          let carrierCategories = data['companyModel'];
          if (carrierCategories != null) {
            if (carrierCategories.length > 0) {
              for (let iCounter = 0; iCounter < carrierCategories.length; iCounter++) {
                this.dropdownListCarrierCategories.push({ "id": parseInt(carrierCategories[iCounter].carrierCatId), "itemName": carrierCategories[iCounter].carrierCatName });
              }

              if (this.editModel != null) {
                if (this.editModel.listOfCarrierCategory != null) {
                  if (this.editModel.listOfCarrierCategory.length > 0) {
                    for (let iCounter = 0; iCounter < this.editModel.listOfCarrierCategory.length; iCounter++) {
                      if (this.editModel.listOfCarrierCategory[iCounter].carrierName != null) {
                        this.selectedItemsCarrierCategories.push({ "id": this.editModel.listOfCarrierCategory[iCounter].carrierCatId, "itemName": this.editModel.listOfCarrierCategory[iCounter].carrierName });
                        this.listofcarriercategories.push(this.editModel.listOfCarrierCategory[iCounter].carrierCatId);
                      }
                    }
                  }
                }
              }
            }
          }
        }

        this.dropdownCarrierCategoriesSettings = {
          singleSelection: false,
          text: "Select Carrier Type Summary",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No carrier type summary available',
          showCheckbox: true
        };
      });
  }

  onSelectedCarrierCategories($event) {
    if (this.listofcarriercategories != null) {
      if (this.listofcarriercategories.length > 0) {
        this.listofcarriercategories = this.removeElemetninArray(this.listofcarriercategories, $event.id)
        this.listofcarriercategories.push($event.id);
      }
      else {
        this.listofcarriercategories.push($event.id);
      }
    }
  }

  onDeSelectedCarrierCategories($event) {
    if (this.listofcarriercategories != null) {
      if (this.listofcarriercategories.length > 0) {
        this.listofcarriercategories = this.removeElemetninArray(this.listofcarriercategories, $event.id)
      }
    }
  }

  onSelectAllCarrierCategories($event) {
    for (let iCounter = 0; iCounter < $event.length; iCounter++) {
      if (this.listofcarriercategories != null) {
        if (this.listofcarriercategories.length > 0) {
          this.listofcarriercategories = this.removeElemetninArray(this.listofcarriercategories, $event[iCounter].id)
          this.listofcarriercategories.push($event[iCounter].id);
        }
        else {
          this.listofcarriercategories.push($event[iCounter].id);
        }
      }
    }
  }

  onDeSelectAllCarrierCategories($event) {
    this.listofcarriercategories = [];
  }

  GetStates(userId: any, productId: any) {
    this.matrix.getState(this.tokenKey, userId, productId).subscribe(
      data => {
        if (data["state"] != null) {
          this.selectedItemsState = [];
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }

          if (this.editModel != null) {
            if (this.editModel.listOfState != null) {
              if (this.editModel.listOfState.length > 0) {
                for (let iCounter = 0; iCounter < this.editModel.listOfState.length; iCounter++) {
                  if (this.editModel.listOfState[iCounter].stateName != null) {
                    this.selectedItemsState.push({ "id": this.editModel.listOfState[iCounter].stateId, "itemName": this.editModel.listOfState[iCounter].stateName });
                    this.listofState.push(this.editModel.listOfState[iCounter].stateId);
                  }
                }
              }
            }
          }
        }

        this.setStateSettings();
      }, error => {

      })
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectedState($event) {
    if (this.listofState != null) {
      if (this.listofState.length > 0) {
        this.listofState = this.removeElemetninArray(this.listofState, $event.id)
        this.listofState.push($event.id);
      }
      else {
        this.listofState.push($event.id);
      }
    }
  }

  onDeSelectedState($event) {
    if (this.listofState != null) {
      if (this.listofState.length > 0) {
        this.listofState = this.removeElemetninArray(this.listofState, $event.id)
      }
    }
  }

  onSelectAllState($event) {
    for (let iCounter = 0; iCounter < $event.length; iCounter++) {
      if (this.listofState != null) {
        if (this.listofState.length > 0) {
          this.listofState = this.removeElemetninArray(this.listofState, $event[iCounter].id)
          this.listofState.push($event[iCounter].id);
        }
        else {
          this.listofState.push($event[iCounter].id);
        }
      }
    }
  }

  onDeSelectAllState($event) {
    this.listofState = [];
  }

  isDeadlineDate(dateArray: any) {
    if (dateArray != null) {
      let dd1 = dateArray.getDate().toString();
      if (parseInt(dd1.toString()) < 10)
        dd1 = '0' + dd1.toString();

      let mm1 = (dateArray.getMonth() + 1).toString();
      if (parseInt(mm1.toString()) < 10)
        mm1 = '0' + mm1.toString();

      this.addNewActionModel.deadLineDate = mm1 + '-' + dd1 + '-' + dateArray.getFullYear();
    }
    else
      this.addNewActionModel.deadLineDate = null;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  onChangeVisible(event) {
    this.isSpecificUserVisible = false;
    this.isCheckVisibleToAllCompanyUsers = false;
    this.selectedItemsUser = [];
    this.selectedItemsVisibleUsers = [];

    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 1 && event.id == 0) {
        document.getElementById("btnvisibletoonlyme").click();
      }

      if (this.isReminderUser && this.selectedItemsReminderUsers.length == 0) {
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
      else if (this.selectedItemsReminderUsers.length == 1) {
        if (this.selectedItemsReminderUsers[0].id != this.loginUser) {
          this.selectedItemsReminderUsers = [];
          this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
        }
      }
    }

    if (event) {
      if (Array.isArray(event) && event.length == 0) {
        this.selectedItemsVisible = [];
      }
      else {
        if (event.id == 1) {
          this.isCheckVisibleToAllCompanyUsers = true;
        }
        else if (event.id == 2) {
          this.isCheckVisibleToAllCompanyUsers = true;
          this.isSpecificUserVisible = true;
        }
      }
    }
    this.AssignUserDropDownSettings();
  }
  onChangeCountry(event) {
    this.isCountryUserSelected = false;
    this.selectedItemsState = [];
    this.listofState = [];
    if (event && event.itemName != 'United States (USA)') {
      this.isCountryUserSelected = true;
    }
    this.setStateSettings();
  }
  onChangeReminder(event) {
    this.isReminderUser = false;
    this.selectedItemsReminderUsers = [];
    if (event) {
      if (Array.isArray(event) && event.length == 0) {
        this.isReminderUser = false;
      }
      else if (event.id != 'None') {
        this.isReminderUser = true;
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
    }
  }
  onChangeCategory(event) {
    this.isAddNewCategory = false;
    if (event) {
      if (event.id < 0) {
        this.isAddNewCategory = true;
      }
    }
  }
  setStateSettings() {
    this.dropdownStateSettings = {
      singleSelection: false,
      text: "Select State(s)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No state available',
      showCheckbox: true,
      enableFilterSelectAll: false,
      enableCheckAll: true,
      disabled: this.isCountryUserSelected
    };
  }
  AssignUserDropDownSettings() {
    this.dropdownUserSettings = {
      singleSelection: true,
      text: "Select User",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No user available',
      showCheckbox: false,
      disabled: !this.isCheckVisibleToAllCompanyUsers
    };
  }
  GetAllCountry() {
    this.actionItemServices.getCountry(this.tokenKey).subscribe(data => {
      if (data['status'] == 'Success') {
        for (let iCounter = 0; iCounter < data.countryList.length; iCounter++) {
          this.dropdownListCountry.push({ "id": parseInt(data.countryList[iCounter].countryId), "itemName": (data.countryList[iCounter].name + ' (' + data.countryList[iCounter].shortName + ')') });
        }
        if (this.editModel != null)
          this.selectedItemsCountry = this.dropdownListCountry.filter(x => x.id == this.editModel.country);
        this.addNewActionModel.country = this.editModel.country;
        if (this.editModel.country > 0 && this.editModel.country != 236)
          this.isCountryUserSelected = true;
      }
      this.dropdownCountrySettings = {
        singleSelection: true,
        text: "Select Country",
        enableSearchFilter: true,
        classes: "borderLessTextBoxGreen",
        badgeShowLimit: 3,
        noDataLabel: 'No country available',
        showCheckbox: false
      };
      this.setStateSettings();
    })
  }
  GetAllVisible() {
    this.dropdownListVisible.push({ "id": 0, "itemName": "Visible to me only" });
    this.dropdownListVisible.push({ "id": 1, "itemName": "Visible to all company users" });
    this.dropdownListVisible.push({ "id": 2, "itemName": "Visible to specific users " });
    if (this.editModel != null) {
      this.selectedItemsVisible = this.dropdownListVisible.filter(x => x.id == this.editModel.visibleTrackIt);
      this.selectedItemsVisibleUsers = this.editModel.visibleUserIds;
      this.addNewActionModel.visibleTrackIt = this.editModel.visibleTrackIt;
      if (this.editModel.visibleTrackIt == 2)
        this.isSpecificUserVisible = true;
    }
  }
  GetAllRecurrance() {
    this.dropdownListRecurrance.push({ "id": 'None', "itemName": "None" });
    this.dropdownListRecurrance.push({ "id": 'Annual', "itemName": "Annual" });
    this.dropdownListRecurrance.push({ "id": 'Quarterly', "itemName": "Quarterly" });
    this.dropdownListRecurrance.push({ "id": 'Every 2 months', "itemName": "Every 2 months" });
    this.dropdownListRecurrance.push({ "id": 'Every 1 month', "itemName": "Every 1 month" });
    this.dropdownListRecurrance.push({ "id": 'Every 2 weeks', "itemName": "Every 2 weeks" });
    if (this.editModel != null) {
      this.selectedItemsRecurrance = this.dropdownListRecurrance.filter(x => x.id == this.editModel.recurrance);
      this.addNewActionModel.recurrance = this.editModel.recurrance;
    }
  }
  GetAllReminders() {
    this.dropdownListReminder.push({ "id": 'None', "itemName": "None" });
    this.dropdownListReminder.push({ "id": 'Before 2 months', "itemName": "Before 2 months" });
    this.dropdownListReminder.push({ "id": 'Before 1 month', "itemName": "Before 1 month" });
    this.dropdownListReminder.push({ "id": 'Before 2 weeks', "itemName": "Before 2 weeks" });
    this.dropdownListReminder.push({ "id": 'Before 1 day', "itemName": "Before 1 day" });
    if (this.editModel != null) {
      this.selectedItemsReminder = this.dropdownListReminder.filter(x => x.id == this.editModel.reminder);
      this.selectedItemsReminderUsers = this.editModel.reminderUsers;
      this.addNewActionModel.reminder = this.editModel.reminder;
      if (this.editModel.reminder != 'None')
        this.isReminderUser = true;
    }
  }
  GetAllCompanyServiceCategory(isSelectItem = true) {
    this.dropdownListCompanySpecificCategory = [];
    this.actionItemServices.GetAllActionCompanySpecificCategory(this.tokenKey, this.companyId).subscribe(data => {
      if (data['status'] == 'Success') {
        if (data.result != null) {
          if (data.result.length > 0) {
            for (let iCounter = 0; iCounter < data.result.length; iCounter++) {
              this.dropdownListCompanySpecificCategory.push({ "id": parseInt(data.result[iCounter].actionCompanySpecificCategoryId), "itemName": data.result[iCounter].name });
            }
          }
          this.dropdownListCompanySpecificCategory.push({ id: -1, itemName: "New >" });
          if (this.editModel != null && isSelectItem)
            this.selectedItemsCompanySpecificCategory = this.dropdownListCompanySpecificCategory.filter(x => x.id == this.editModel.category);
        }
      }
    })
  }
  saveCompanySpecificCategory() {
    if (!this.addNewCategoryText) {
      this.showMessage('Please enter category name', 'Error', 'error');
      return;
    }
    const category = new ActionCompanySpecificCategoryModel();
    category.companyId = this.companyId;
    category.name = this.addNewCategoryText;
    category.createdBy = this.loginUser;
    this.actionItemServices.ActionCompanySpecificCategoryAddUpdate(this.tokenKey, category).subscribe(
      data => {
        this.isOneClickOnButton = false;
        if (data['status'] == 'Success') {
          this.showMessage('Entry saved successfully', 'Success', 'success');
          this.selectedItemsCompanySpecificCategory = [];
          const item = { id: data.result, itemName: this.addNewCategoryText };
          this.selectedItemsCompanySpecificCategory.push(item);
          this.GetAllCompanyServiceCategory(false);
          this.addNewCategoryText = '';
          this.isAddNewCategory = false;
        }
        else if (data.result == -1) {
          this.showMessage('Category name is already exists.', 'Error', 'error');
        }
        else {
          this.showMessage(data['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
        this.isOneClickOnButton = false;
      });
  }

  onSelectedReminderUser($event) {
    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 1) {
        if (this.selectedItemsVisible[0].id == 0) {
          this.selectedItemsReminderUsers = this.removeElemetsFromArray(this.selectedItemsReminderUsers, $event.id)
          document.getElementById("btnvisibletoonlyme").click();
        }
        else {
          this.selectedItemsReminderUsers = this.removeElemetsFromArray(this.selectedItemsReminderUsers, $event.id)
          this.selectedItemsReminderUsers.push($event);
        }
      }
      else {
        if (this.selectedItemsVisible[0].id == 0 && $event.id != this.loginUser) {
          this.selectedItemsReminderUsers = [];
          this.showMessage('You can not select other user because trac-it visibility is only me', 'Error', 'error');
        }
      }
    }
  }

  onSelectedAllReminderUser($event) {
    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 0 && this.selectedItemsVisible.length > 0) {
        if (this.selectedItemsVisible[0].id == 0) {
          this.selectedItemsReminderUsers = [];
          this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
          document.getElementById("btnvisibletoonlyme").click();
        }
      }
    }
  }

  removeElemetsFromArray(array, element) {
    this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
    return array.filter(e => e.id !== element);
  }

  clearSelectedVisibleItem() {
    this.selectedItemsVisible = [];
  }

  onDeselectedAllReminderUser($event) {
    this.selectedItemsReminderUsers = [];
    if (this.selectedItemsVisible.length > 0) {
      if (this.selectedItemsVisible[0].id == 0 && this.selectedItemsReminderUsers.length == 0) {
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
    }
  }

  onDeselectedReminderUser($event) {
    if (this.selectedItemsVisible.length > 0) {
      if (this.selectedItemsVisible[0].id == 0 && this.selectedItemsReminderUsers.length == 0 && $event.id == this.loginUser) {
        this.showMessage('You can not remove current user from reminder user', 'Error', 'error');
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
    }
  }
}
